import React, { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { useI18n } from "@/i18n";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ScrollText } from "lucide-react";
import { toast } from "sonner";

export default function DocumentLogs() {
  const { t } = useI18n();
  const [access, setAccess] = useState([]);
  const [pdf, setPdf] = useState([]);
  useEffect(() => {
    api.get("/registry/logs").then((r) => { setAccess(r.data.access_logs); setPdf(r.data.pdf_logs); })
      .catch((e) => toast.error(apiErr(e.response?.data?.detail)));
  }, []);
  const ts = (v) => (v || "").slice(0, 19).replace("T", " ");
  return (
    <div data-testid="document-logs">
      <div className="flex items-center gap-3 mb-4"><ScrollText className="h-6 w-6 text-primary" /><h1 className="text-2xl font-display font-bold text-slate-900">{t("documentLogs")}</h1></div>
      <Tabs defaultValue="access">
        <TabsList>
          <TabsTrigger value="access" data-testid="tab-access-logs">{t("accessLogs")}</TabsTrigger>
          <TabsTrigger value="pdf" data-testid="tab-pdf-logs">{t("pdfLogs")}</TabsTrigger>
        </TabsList>
        <TabsContent value="access">
          <Card className="card-float border-slate-200 overflow-hidden">
            <Table>
              <TableHeader><TableRow className="bg-slate-50/70"><TableHead>{t("date")}</TableHead><TableHead>{t("user")}</TableHead><TableHead>Action</TableHead><TableHead>Source</TableHead><TableHead>{t("sensitive")}</TableHead></TableRow></TableHeader>
              <TableBody>
                {access.length === 0 ? <TableRow><TableCell colSpan={5} className="text-center text-slate-400 py-8">{t("noData")}</TableCell></TableRow> :
                  access.slice(0, 200).map((l, i) => (
                    <TableRow key={i} data-testid="access-log-row">
                      <TableCell className="text-xs text-slate-500">{ts(l.created_at)}</TableCell>
                      <TableCell className="text-sm text-slate-700">{l.user_name || "—"}</TableCell>
                      <TableCell className="text-sm">{l.action}</TableCell>
                      <TableCell className="text-xs text-slate-500">{l.source || "—"}</TableCell>
                      <TableCell>{l.sensible ? <Badge className="bg-red-100 text-red-700 border-0 text-xs">🔒</Badge> : ""}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </Card>
        </TabsContent>
        <TabsContent value="pdf">
          <Card className="card-float border-slate-200 overflow-hidden">
            <Table>
              <TableHeader><TableRow className="bg-slate-50/70"><TableHead>{t("date")}</TableHead><TableHead>Type</TableHead><TableHead>{t("user")}</TableHead></TableRow></TableHeader>
              <TableBody>
                {pdf.length === 0 ? <TableRow><TableCell colSpan={3} className="text-center text-slate-400 py-8">{t("noData")}</TableCell></TableRow> :
                  pdf.slice(0, 200).map((l, i) => (
                    <TableRow key={i} data-testid="pdf-log-row">
                      <TableCell className="text-xs text-slate-500">{ts(l.generated_at)}</TableCell>
                      <TableCell className="text-sm">{l.pdf_type || l.type || "—"}</TableCell>
                      <TableCell className="text-sm text-slate-700">{l.generated_by || l.user_name || "—"}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </Card>
        </TabsContent>
      </Tabs>
    </div>
  );
}
